export default "/images/ic-cancel.svg?438b47b9bfd4e8fb8b1c85bcc1c9bf7a";